import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-chamaster',
  templateUrl: './chamaster.component.html',
  styleUrls: ['./chamaster.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChamasterComponent implements OnInit {

  EditedChaId: any;
  AgentCode: string;
  CompanyName: string;
  Branch: string;
  Location: string;
  Address1: string;
  Address2: string;
  Country: string;
  State: string;
  Postal: string;
  Contactname: string;
  Designation: string;
  Contactnum: string;
  Email: string;
  Pannum: string;
  Chacode: string;
  Description: string;
  select = [] as any;
  type: string;
  Status: boolean = false;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  public searchText: string;
  CHAExport = [] as any;
  EditedCha = [] as any;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  dropdownList: any = [];
  dropdownSettings: IDropdownSettings;
  cchaname :string;
  cchaId : string;
  countrys = [];
  countryid: string;
  countryname: string;

  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'agentcode', 'companyname', 'location', 'contactname', 'contactnum', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('ChaRead');
    this.vWrite = localStorage.getItem('ChaWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.getChaCOde();
    this.BindCHAGrid();
    this.BindCHAExport();
    this.BindCountryDDL();


    this.dropdownList = [
      { item_id: 1, item_text: 'Ocean Import' },
      { item_id: 2, item_text: 'Ocean Export' },
      { item_id: 3, item_text: 'Air Import' },
      { item_id: 4, item_text: 'Air Export' },
      { item_id: 5, item_text: 'Roadways' },
      { item_id: 6, item_text: 'WareHouse' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };   
    //console.log(this.select+"1")
  }


  BindCountryDDL() {
    var value = this.http.get(environment.apiUrl + 'Cha/GetCountryDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.countrys = data;
          this.countryid = "0";
        }
        else {
        };
      });
  }



  onItemSelect(item: any) {     
    debugger;  
    if (this.type == undefined || this.type == null || this.type == "") {
      this.type = item.item_text;
    }
    else {
      this.type = this.type + "," + item.item_text;
    }
  }
  onSelectAll(item: any) {
    debugger;
    this.type="";
    if(item.length > 0)
    {
      for(var i=0;i<item.length;i++)
      {
        if (this.type == undefined || this.type == null || this.type == "") {
          var items = item[i];
          this.type = items.item_text;
          debugger;
        }
        else {
          var items = item[i];
          this.type = this.type + "," + items.item_text;
          debugger;         
        }
      }
    }
   
  }
  onItemDeSelect(item: any) {
    debugger;
    var vItmsTyp = this.type.split(',');
    this.type = "";
    for (var i = 0; i < vItmsTyp.length; i++) {
      if (item.item_text == vItmsTyp[i]) {

      }
      else
      {
        if (this.type == undefined || this.type == null || this.type == "") {
          this.type = vItmsTyp[i];
        }
        else {
          this.type = this.type + "," + vItmsTyp[i];
        }
      }
    }
  }

  SubmitCha() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vAgentCode = this.AgentCode;
    var vCompanyName = this.CompanyName;
    var vbranch = this.Branch;
    var vlocation = this.Location;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vcountry = this.Country;
    var vState = this.State;
    var vpostal = this.Postal;
    var vcontactName = this.Contactname;
    var vdesignation = this.Designation;
    var vcontactnumber = this.Contactnum;
    var vEmailid = this.Email;
    var vchapan = this.Pannum;
    var vchacode = this.Chacode;
    var vdescription = this.Description;
    var vselect = this.type;

    debugger;


    if (vAgentCode == undefined || vAgentCode == "" || vAgentCode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Agent Code.";
      return false;
    }

    if (vCompanyName == undefined || vCompanyName == "" || vCompanyName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Company Name.";
      return false;
    }

    if (vbranch == undefined || vbranch == "" || vbranch == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Branch.";
      return false;
    }

    if (vlocation == undefined || vlocation == "" || vlocation == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Location.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1="";
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2="";
    }

    if (vcountry == undefined || vcountry == "" || vcountry == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country.";
      return false;
    }

    if (vState == undefined || vState == "" || vState == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter State.";
      return false;
    }

    if (vpostal == undefined || vpostal == "" || vpostal == "0") {
      this.Postal="";
    }

    if (vcontactName == undefined || vcontactName == "" || vcontactName == "0") {
      this.Contactname="";
    }

    if (vdesignation == undefined || vdesignation == "" || vdesignation == "0") {
      this.Designation="";
    }

    if (vcontactnumber == undefined || vcontactnumber == "" || vcontactnumber == "0") {
     this.Contactnum="";
    }

    if (vEmailid == undefined || vEmailid == "" || vEmailid == "0") {
     this.Email="";
    }

    if (vchapan == undefined || vchapan == "" || vchapan == "0") {
      this.Pannum="";
    }

    if (vchacode == undefined || vchacode == "" || vchacode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Cha Code.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.Description="";
    }


    if (vselect == undefined || vselect == "" || vselect == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Ocean/Air/Roadways";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dAgentCode', this.AgentCode);
    params = params.append('dCompanyName', this.CompanyName);
    params = params.append('dbranch', this.Branch);
    params = params.append('dlocation', this.Location);
    params = params.append('dAddress1', this.Address1);
    params = params.append('dAddress2', this.Address2);
    params = params.append('dcountry', this.Country);
    params = params.append('dstate', this.State);
    params = params.append('dpostal', this.Postal);
    params = params.append('dcontactname', this.Contactname);
    params = params.append('ddesignation', this.Designation);
    params = params.append('dcontactnumber', this.Contactnum);
    params = params.append('demail', this.Email);
    params = params.append('dpannum', this.Pannum);
    params = params.append('dchacode', this.Chacode);
    params = params.append('ddescription', this.Description);
    params = params.append('dselect', this.type);
    var value = this.http.get(environment.apiUrl + 'Cha/InsertCHA', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var countrycode = data;
        this.AgentCode = "";
        this.CompanyName = "";
        this.Branch = "";
        this.Location = "";
        this.Address1 = "";
        this.Address2 = "";
        this.Country = "";
        this.State = "";
        this.Postal = "";
        this.Contactname = "";
        this.Designation = "";
        this.Email = "";
        this.Pannum = "";
        this.Chacode = "";
        this.Description = "";
        this.Contactnum = "";
        this.select = "";  
        this.type="";
        this.SuccessMsg = "CHA Master Added."
        this.BindCHAGrid();
        this.BindCHAExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }


  EditCHA(item: any) {   
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedCha = item;
    var vChaId = this.EditedCha.chaId;
    var vAgentCode = this.EditedCha.agentcode;
    var vCompanyName = this.EditedCha.companyname;
    var vbranch = this.EditedCha.branch;
    var vlocation = this.EditedCha.location;
    var vAddress1 = this.EditedCha.address1;
    var vAddress2 = this.EditedCha.address2;
    var vcountry = this.EditedCha.country;
    var vState = this.EditedCha.state;
    var vpostal = this.EditedCha.zip;
    var vcontactName = this.EditedCha.contactname;
    var vdesignation = this.EditedCha.designation;
    var vcontactnumber = this.EditedCha.contactnum;
    var vEmailid = this.EditedCha.emailid;
    var vchapan = this.EditedCha.pan;
    var vchacode = this.EditedCha.chacode;
    var vdescription = this.EditedCha.description;
    var vselect = this.EditedCha.type;

    this.EditedChaId = vChaId;
    this.AgentCode = vAgentCode;
    this.CompanyName = vCompanyName;
    this.Branch = vbranch;
    this.Location = vlocation;
    this.Address1 = vAddress1;
    this.Address2 = vAddress2;
    this.Country = vcountry;
    this.State = vState;
    this.Postal = vpostal;
    this.Contactname = vcontactName;
    this.Designation = vdesignation;
    this.Email = vEmailid;
    this.Pannum = vchapan;
    this.Chacode = vchacode;
    this.Description = vdescription;
    this.Contactnum = vcontactnumber;
    debugger;     
    
    if (vselect != null || vselect != undefined || vselect != "") {
      var Stype = vselect.split(",");
      this.select=[];    
      for (var i = 0; i < Stype.length; i++) {
        // var temp = {};
        // temp['item_text'] = Stype[i];  
        var vText=Stype[i];
        var vItmId=0;
        switch(Stype[i])   
        {
          case "Ocean Import":
            vItmId=1;
          break;
          case "Ocean Export":
            vItmId=2;
            break;
            case "Air Import":
            vItmId=3;
            break;
            case "Air Export":
            vItmId=4;
            break;
            case "Roadways":
            vItmId=5;
            break;
            case "WareHouse":
            vItmId=6;
            break;
        }
         
        this.select.push({item_id:vItmId,item_text:vText});
        if (this.type == undefined || this.type == null || this.type == "") {
          this.type = vText;
        }
        else {
          this.type = this.type + "," + vText;
        }
      }
    }
    var vStatus = this.EditedCha.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }

  UpdateCha() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vAgentCode = this.AgentCode;
    var vCompanyName = this.CompanyName;
    var vbranch = this.Branch;
    var vlocation = this.Location;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vcountry = this.Country;
    var vState = this.State;
    var vpostal = this.Postal;
    var vcontactName = this.Contactname;
    var vdesignation = this.Designation;
    var vcontactnumber = this.Contactnum;
    var vEmailid = this.Email;
    var vchapan = this.Pannum;
    var vchacode = this.Chacode;
    var vdescription = this.Description;
    var vselect = this.type;
    debugger;


    if (vAgentCode == undefined || vAgentCode == "" || vAgentCode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Agent Code.";
      return false;
    }

    if (vCompanyName == undefined || vCompanyName == "" || vCompanyName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Company Name.";
      return false;
    }

    if (vbranch == undefined || vbranch == "" || vbranch == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Branch.";
      return false;
    }

    if (vlocation == undefined || vlocation == "" || vlocation == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Location.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1="";
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2="";
    }

    if (vcountry == undefined || vcountry == "" || vcountry == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country.";
      return false;
    }

    if (vState == undefined || vState == "" || vState == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter State.";
      return false;
    }

    if (vpostal == undefined || vpostal == "" || vpostal == "0") {
      this.Postal="";
    }

    if (vcontactName == undefined || vcontactName == "" || vcontactName == "0") {
      this.Contactname="";
    }

    if (vdesignation == undefined || vdesignation == "" || vdesignation == "0") {
      this.Designation="";
    }

    if (vcontactnumber == undefined || vcontactnumber == "" || vcontactnumber == "0") {
     this.Contactnum="";
    }

    if (vEmailid == undefined || vEmailid == "" || vEmailid == "0") {
     this.Email="";
    }

    if (vchapan == undefined || vchapan == "" || vchapan == "0") {
      this.Pannum="";
    }

    if (vchacode == undefined || vchacode == "" || vchacode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Cha Code.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.Description="";
    }


    if (vselect == undefined || vselect == "" || vselect == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Ocean/Air/Roadways";
      return false;
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('dAgentCode', this.AgentCode);
    params = params.append('dCompanyName', this.CompanyName);
    params = params.append('dbranch', this.Branch);
    params = params.append('dlocation', this.Location);
    params = params.append('dAddress1', this.Address1);
    params = params.append('dAddress2', this.Address2);
    params = params.append('dcountry', this.Country);
    params = params.append('dstate', this.State);
    params = params.append('dpostal', this.Postal);
    params = params.append('dcontactname', this.Contactname);
    params = params.append('ddesignation', this.Designation);
    params = params.append('dcontactnumber', this.Contactnum);
    params = params.append('demail', this.Email);
    params = params.append('dpannum', this.Pannum);
    params = params.append('dchacode', this.Chacode);
    params = params.append('ddescription', this.Description);
    params = params.append('dselect', this.type);
    params = params.append('iChaId', this.EditedChaId);
    params = params.append('istatus', vStatus);
    var value = this.http.get(environment.apiUrl + 'Cha/UpdateCHA', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var countrycode = data;
        this.AgentCode = "";
        this.CompanyName = "";
        this.Branch = "";
        this.Location = "";
        this.Address1 = "";
        this.Address2 = "";
        this.Country = "";
        this.State = "";
        this.Postal = "";
        this.Contactname = "";
        this.Designation = "";
        this.Email = "";
        this.Pannum = "";
        this.Chacode = "";
        this.Description = "";
        this.Contactnum = "";
        this.select = "";      
        this.type="";  
        this.Status = false;
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn = true;
        this.isShownActive=true;
        this.SuccessMsg = "Cha Master Updated.";
        this.BindCHAExport();
        this.BindCHAGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  ClearCha() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.AgentCode = "";
    this.CompanyName = "";
    this.Branch = "";
    this.Location = "";
    this.Address1 = "";
    this.Address2 = "";
    this.Country = "";
    this.State = "";
    this.Postal = "";
    this.Contactname = "";
    this.Designation = "";
    this.Email = "";
    this.Pannum = "";
    this.Chacode = "";
    this.Description = "";
    this.Contactnum = "";
    this.select = "";
    this.type="";
    this.Status = false;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;

  }

  getChaCOde()
  {
    var value = this.http.get(environment.apiUrl + 'Cha/GetCHACode').toPromise().then(
      (data: any) => {
        debugger;        
        var chacode = data;       
        var ccode = chacode[0];
        var scode = ccode.chaid;        
        this.cchaId = scode;
        this.cchaname = "CHA0";
        this.AgentCode = this.cchaname + "" +this.cchaId;
      });
  }

  BindCHAGrid() {
    var value = this.http.get(environment.apiUrl + 'Cha/GetCHAForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindCHAExport() {
    var value = this.http.get(environment.apiUrl + 'Cha/GetCHAForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.CHAExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.CHAExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'CHA');

    /* save to file */
    XLSX.writeFile(wb, "CHA.xlsx");

  }


}
